import cliffboro from "./cliffboro-1955.json";
import devilsCreek from "./devils_creek-1923.json";
import litchfield from "./litchfield-1885.json";

const previousEngagements = [cliffboro, devilsCreek, litchfield];

export default previousEngagements;